export const FETCH_EMAILS_SUCCESS = "app/emails/FETCH_EMAILS_SUCCESS";
export const FETCH_EMAILS_FAIL = "app/emails/FETCH_EMAILS_FAIL";

export const FETCH_NOTIFIER_EMAILS_SUCCESS = "app/emails/FETCH_NOTIFIER_EMAILS_SUCCESS";
export const FETCH_NOTIFIER_EMAILS_FAIL = "app/emails/FETCH_NOTIFIER_EMAILS_FAIL";
